'use client';

import React, { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { PerformanceLabTypeformSnippet } from 'components/performance-lab/PerformanceLabTypeformSnippet';
import {
  buildTypeformTrackingFromUrl,
  getPageUrlUtmSource,
} from 'lib/analytics/buildTypeformTrackingParams';
import { PERFORMANCE_LAB_BOOK_TOUR_TYPEFORM_ID } from 'content/vo2MaxBannerConfig';
import { PerformanceLabModalBodyScrollLock } from './PerformanceLabModalBodyScrollLock';
import styles from './WaitlistTypeformModal.module.css';

type PerformanceLabTFModalProps = {
  planId?: string;
  typeformId?: string;
};

export const PerformanceLabTFModal: React.FC<PerformanceLabTFModalProps> = ({
  planId,
  typeformId = PERFORMANCE_LAB_BOOK_TOUR_TYPEFORM_ID,
}) => {
  const tCommon = useTranslations('common');

  const trackingParams = useMemo(
    () =>
      buildTypeformTrackingFromUrl({
        utm_source: getPageUrlUtmSource(),
        utm_medium: planId ?? 'web',
      }),
    [planId],
  );

  return (
    <PerformanceLabModalBodyScrollLock>
      <div className={styles.modalRoot}>
        <div className={styles.typeformContainer}>
          <PerformanceLabTypeformSnippet
            typeformId={typeformId}
            frameTitle={tCommon('waitlistTypeformModal.typeformSnippet.frameTitle')}
            className="typeform-container"
            trackingParams={trackingParams}
          />
        </div>
      </div>
    </PerformanceLabModalBodyScrollLock>
  );
};
